const mainMenu = document.querySelector('.menu--main');
const menuToggle = document.getElementById('menu-toggle');

if (mainMenu) {
    const submenus = mainMenu.getElementsByClassName('menu-item--expanded');

    if (submenus) {
        // Close all submenus when clicking outside submenu
        document.onclick = function (e) {
            if (!e.target.classList.contains('menu') && !e.target.classList.contains('menu-item--expanded-toggle') && !e.target.classList.contains('submenu')) {
                closeAllSubmenus();
            }
        }

        // Close all submenus when pressing esc
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                closeAllSubmenus();
            }
        })
    }

    // Submenu open and close
    Array.from(submenus).forEach(submenu => {
        let submenuButton = submenu.querySelector('button');

        if (submenuButton) {
            submenuButton.addEventListener('click', (e) => {
                if (submenuButton.getAttribute('aria-expanded') !== 'true') {
                    if (!submenuButton.parentElement.parentElement.parentElement.parentElement.classList.contains('open')) {
                        closeAllSubmenus();
                    }

                    submenu.classList.add('open');
                    submenuButton.setAttribute('aria-expanded', 'true');
                    return;
                }

                submenu.classList.remove('open');
                submenuButton.setAttribute('aria-expanded', 'false');
            });
        }
    });

    function closeAllSubmenus() {
        if (submenus) {
            Array.from(submenus).forEach(submenu => {
                if (submenu.querySelector('button')) {
                    submenu.querySelector('button').setAttribute('aria-expanded', 'false');

                    submenu.classList.remove('open');
                }
            });
        }
    }

    // Hamburger menu toggle
    if (menuToggle) {
        menuToggle.addEventListener('click',  () => {
            if (menuToggle.getAttribute('aria-expanded') === 'true') {
                menuToggle.setAttribute('aria-expanded', 'false');
                document.body.classList.remove('main-menu-active');
                mainMenu.classList.remove('main-menu-open');
                return;
            }

            menuToggle.setAttribute('aria-expanded', 'true');
            document.body.classList.add('main-menu-active')
            mainMenu.classList.add('main-menu-open');
        });

        document.addEventListener('keydown', (e) => {
            if (e.key !== 'Escape') {
                return;
            }

            menuToggle.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('main-menu-active');
            mainMenu.classList.remove('main-menu-open');
        });
    }

    // Hamburger menu accessibility
    const mainMenuList = mainMenu.querySelectorAll('.inner > ul.menu, .menu--secundaire-navigatie, .block-dropdown-language');

    if (mainMenuList) {
        const dropdownLanguage = mainMenuList[mainMenuList.length - 1];
        const dropdownLanguageWrapper = dropdownLanguage.querySelector('.dropbutton-wrapper');
        const lastDropdownOption = dropdownLanguageWrapper.querySelector('.dropbutton').lastChild;
        accessibleHamburger(dropdownLanguageWrapper, lastDropdownOption, menuToggle);
    }

    function accessibleHamburger(lastMenuItemButton, lastSubMenuButton, menuToggle) {
        if (window.innerWidth > 1200) {
            return;
        }

        if (lastMenuItemButton) {
            lastMenuItemButton.addEventListener('keydown', (event) => {
                if (event.shiftKey || lastMenuItemButton.classList.contains('open') || event.key == " " || event.code == "Space" || event.keyCode == 32) {
                    return;
                }

                event.preventDefault();
                menuToggle.focus();
            });
        }

        if (lastSubMenuButton) {
            lastSubMenuButton.addEventListener('keydown', (event) => {
                if (event.shiftKey || event.key == " " || event.code == "Space" || event.keyCode == 32) {
                    return;
                }

                event.preventDefault();
                menuToggle.focus();
            });
        }

        if (menuToggle) {
            menuToggle.addEventListener('keydown', (event) => {
                if (menuToggle.getAttribute('aria-expanded') !== 'true' ) {
                    return;
                }

                if (event.shiftKey) {
                    event.preventDefault();
                    lastMenuItemButton.querySelector('button').focus();
                }
            });
        }
    }
}